import {
  actionSheetController,
  modalController,
  toastController,
} from '@ionic/vue';
import { apolloClient } from '@/graphql/client';
import { createSong } from '@/graphql/mutations';
import { getSongs } from '@/graphql/queries';
import router from '@/router';
import store from '@/store';
import AddToExistingSong from '@/components/songs/AddToExistingSong.vue';

const handleError = async (error: any) => {
  const message = error.message.includes('limit')
    ? "You're out of space! Visit account settings for more info."
    : 'Sorry! We had trouble creating the song. Please try again later.';

  const toast = await toastController.create({
    header: 'Uh oh!',
    message,
    buttons: [
      {
        text: 'Ok',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        },
      },
    ],
  });

  await toast.present();
};

const handleCreateSong = async (file: File) => {
  store.commit('setLoading', true);
  let createSongResponse;
  try {
    createSongResponse = await apolloClient.mutate({
      mutation: createSong,
      variables: {
        title: file.name.replace(/\.[^/.]+$/, ''),
      },
      refetchQueries: [{ query: getSongs }],
    });
  } catch (error) {
    handleError(error);
    return;
  }

  store.dispatch('startFileUpload', {
    selectedFile: file,
    filename: file.name,
    songId: createSongResponse.data.createSong.id,
  });

  router.push(`/song/${createSongResponse.data.createSong.id}?edit=true`);

  store.commit('setLoading', false);
};

export async function useUploadingSingleSongWithActionSheet(file: File) {
  const actionSheet = await actionSheetController.create({
    header: `Add Song${file.name ? `: ${file.name}` : ''}`,
    buttons: [
      {
        text: 'Create a new song',
        async handler() {
          handleCreateSong(file);
        },
        cssClass: 'light-action-sheet-button',
      },
      {
        text: 'Add version to existing song',
        async handler() {
          const modal = await modalController.create({
            component: AddToExistingSong,
            componentProps: {
              file,
            },
          });
          await modal.present();
        },
        cssClass: 'light-action-sheet-button',
      },
      {
        text: 'Cancel',
        role: 'cancel',
        cssClass: 'light-action-sheet-button',
      },
    ],
  });

  await actionSheet.present();
}

export async function useUploadingSingleSongInstant(file: File) {
  await handleCreateSong(file);
}
